import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.imageTargets.forEach((img) => {
      img.style.cursor = "pointer"
    })
  }

  open(event) {
    // Prioriza data-lightbox-large-src (variant 1600px) sobre o src do <img>
    // (thumbnail 800px do feed). Cai pro thumbnail se nao tiver atributo.
    const targetEl = event.currentTarget
    const largeSrc = (el) => el.dataset.lightboxLargeSrc || el.querySelector("img")?.src || el.src
    const src = largeSrc(targetEl)
    if (!src) return

    const images = this.imageTargets.map(largeSrc).filter(Boolean)
    this.currentIndex = images.indexOf(src)
    this.images = images

    // Build overlay com createElement + setAttribute em vez de innerHTML
    // pra ter escape contextual automatico (defesa em profundidade contra
    // futura mudanca onde src/index possa derivar de input de user).
    this.overlay = document.createElement("div")
    this.overlay.className = "lightbox"

    const closeBtn = document.createElement("button")
    closeBtn.className = "lightbox__close"
    closeBtn.type = "button"
    closeBtn.setAttribute("aria-label", "Fechar")
    closeBtn.textContent = "×"
    closeBtn.addEventListener("click", () => this.close())
    this.overlay.appendChild(closeBtn)

    if (images.length > 1) {
      const prevBtn = document.createElement("button")
      prevBtn.className = "lightbox__prev"
      prevBtn.type = "button"
      prevBtn.setAttribute("aria-label", "Anterior")
      prevBtn.textContent = "‹"
      prevBtn.addEventListener("click", () => this.navigate(-1))
      this.overlay.appendChild(prevBtn)
    }

    const img = document.createElement("img")
    img.className = "lightbox__img"
    img.setAttribute("src", src)  // setAttribute escapa contextualmente
    this.overlay.appendChild(img)

    if (images.length > 1) {
      const nextBtn = document.createElement("button")
      nextBtn.className = "lightbox__next"
      nextBtn.type = "button"
      nextBtn.setAttribute("aria-label", "Próxima")
      nextBtn.textContent = "›"
      nextBtn.addEventListener("click", () => this.navigate(1))
      this.overlay.appendChild(nextBtn)

      const counter = document.createElement("span")
      counter.className = "lightbox__counter"
      counter.textContent = `${this.currentIndex + 1} / ${images.length}`
      this.overlay.appendChild(counter)
    }

    this.overlay.addEventListener("click", (e) => { if (e.target === this.overlay) this.close() })

    this._keyHandler = (e) => {
      if (e.key === "Escape") this.close()
      if (e.key === "ArrowLeft") this.navigate(-1)
      if (e.key === "ArrowRight") this.navigate(1)
    }
    document.addEventListener("keydown", this._keyHandler)

    document.body.appendChild(this.overlay)
    document.body.style.overflow = "hidden"
  }

  navigate(dir) {
    if (!this.images || this.images.length <= 1) return
    this.currentIndex = (this.currentIndex + dir + this.images.length) % this.images.length
    this.overlay.querySelector(".lightbox__img").src = this.images[this.currentIndex]
    const counter = this.overlay.querySelector(".lightbox__counter")
    if (counter) counter.textContent = `${this.currentIndex + 1} / ${this.images.length}`
  }

  close() {
    document.removeEventListener("keydown", this._keyHandler)
    document.body.style.overflow = ""
    this.overlay?.remove()
    this.overlay = null
  }

  disconnect() {
    this.close()
  }
}
